<div class="booking-line" *ngIf="line?.booking">
    <span class="booking-line__label">{{"booked_for"|translate}}:</span>
    <ng-container *ngIf="isSlot; else wholeDays">
        <span>{{ days[0]|date: "fullDate" }}, {{ line.booking.start|date: "shortTime" }} &ndash; {{ line.booking.end|date: "shortTime" }}</span>
    </ng-container>
    <ng-template #wholeDays>
        <span *ngIf="isRange; else dayList">
            {{ days[0]|date: "mediumDate" }} &ndash; {{ days[days.length - 1]|date: "mediumDate" }}
            ({{ "booked_days_count"|translate: { count: days.length } }})
        </span>
        <ng-template #dayList>
            <span *ngFor="let day of days; let last = last">{{ day|date: "mediumDate" }}<ng-container *ngIf="!last">, </ng-container></span>
        </ng-template>
    </ng-template>
</div>
